import React, {useState, useEffect} from 'react';
import Axios from 'axios';

import ModalAccessories from '../Modals/ModalAccessories';

import useAccessoriesData from '../../hooks/useAccessoriesData';
import useFinanciadoData from '../../hooks/useFinanciadoData';
import useConfiguratorData from '../../hooks/useConfiguratorData';

const AccessoriesSelector = () => {

    const {getAddedAccessories, getIgnoreAccessories, setIgnoreAccessories, getAccessories, setAccessories, setFilteredAccessories, setCategories} = useAccessoriesData();
    const { getSelectedVersion } = useConfiguratorData();
    const { resetFinanciado } = useFinanciadoData();

    const addedAccessories = getAddedAccessories();
    const ignoreAccessories = getIgnoreAccessories();
    const accessories = getAccessories();
    const selectedVersion = getSelectedVersion();

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (addedAccessories.length) setIgnoreAccessories(false);
        else setIgnoreAccessories(true);
    }, [addedAccessories])

    const handleAddAccesories = () => {
        setIsOpen(true);
        setIgnoreAccessories(false);
    }

    const handleOmitAccessories = () => {
        if (!ignoreAccessories.value) {
            resetFinanciado();
        }
        setIgnoreAccessories(true);
    }

    useEffect(() => {
        if (!accessories.length) {
            Axios.get(`/api/vehicles/bnp/accessories/${selectedVersion.id}/`).then(response => {
                let data = response.data.map(element => {
                    let copy = {...element};
                    copy.is_added = false;
                    return copy;
                })
                //Categorias para filtrar
                let accessoriesCategories = new Set();
                let categoriesCount = {};
                accessoriesCategories.add('Todos');
                data.forEach(accessory => {
                    accessoriesCategories.add(accessory.category);
                });
                setCategories([...accessoriesCategories]);
                setAccessories(data);
                setFilteredAccessories(data)
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
    }, [])

    return (
        <div className="accessories-selector" style={accessories.length == 0 ? {display: 'none'} : {}}>
            <div className="component-header">
                <h2>Toyota Accesorios Originales</h2>
                <div className="component-subtitle">Elige los accesorios que te gustaría agregar a tu vehículo</div>
            </div>
            <div className="component-body">
                <div className={"item-box " + (!ignoreAccessories.value ? 'active' : '')} onClick={() => handleAddAccesories()}>
                    {addedAccessories.length ? 
                        <span>Accesorios agregados ({addedAccessories.length}) <small>Editar <i className="icon chevron-strong"></i></small></span>
                    :   
                        <span>Agregar accesorios</span>
                    }
                </div>
                <div className={"item-box " + (ignoreAccessories.value ? 'active' : '')} onClick={() => handleOmitAccessories()}>
                    <span>Omitir por ahora</span>
                </div>
            </div>
            <ModalAccessories isOpen={isOpen} onCloseModal={() => setIsOpen(false)}/>
        </div>
    )
}

export default AccessoriesSelector;